require("core-js/modules/es.array.reduce.js");

var _inherits = require("@babel/runtime/helpers/inherits");

var _setPrototypeOf = require("@babel/runtime/helpers/setPrototypeOf");

require("core-js/modules/es.array.reduce.js");

function _wrapRegExp() {
  _wrapRegExp = function _wrapRegExp(re, groups) {
    return new BabelRegExp(re, void 0, groups);
  };

  var _super = RegExp.prototype,
      _groups = new WeakMap();

  function BabelRegExp(re, flags, groups) {
    var _this = new RegExp(re, flags);

    return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype);
  }

  function buildGroups(result, re) {
    var g = _groups.get(re);

    return Object.keys(g).reduce(function (groups, name) {
      return groups[name] = result[g[name]], groups;
    }, Object.create(null));
  }

  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);

    return result && (result.groups = buildGroups(result, this)), result;
  }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if ("string" == typeof substitution) {
      var groups = _groups.get(this);

      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    }

    if ("function" == typeof substitution) {
      var _this = this;

      return _super[Symbol.replace].call(this, str, function () {
        var args = arguments;
        return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
      });
    }

    return _super[Symbol.replace].call(this, str, substitution);
  }, _wrapRegExp.apply(this, arguments);
}

module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = "./src/support-center-parser.tsx");
  /******/
}
/************************************************************************/

/******/
({
  /***/
  "./src/index.tsx":
  /***/
  function srcIndexTsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: external "react"


    var external_react_ = __webpack_require__("react");

    var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_); // EXTERNAL MODULE: ./src/lexer/lexer.js


    var lexer = __webpack_require__("./src/lexer/lexer.js");

    var lexer_default = /*#__PURE__*/__webpack_require__.n(lexer); // CONCATENATED MODULE: ./src/lexer-parser.ts


    var Definitions = function Definitions() {
      var ld = lexer_default.a.definition();
      ld.define('default', 'default');
      ld.define('boolean', 'true');
      ld.define('boolean', 'false');
      ld.define('integer', '[0123456789][0123456789]*');
      ld.define('string', '[a-zA-Z_][a-zA-Z0-9_]*');
      ld.define('if_start', '{{#if ');
      ld.define('if_end', '{{/if}}');
      ld.define('mustache_start', '{{');
      ld.define('mustache_end', '}}');
      ld.define('space', ' ');
      ld.define('header', ['#', '##', '###']);
      ld.define('block', ['> ', ' > ', '  > ']);
      ld.define('element_start', ['<', '&lt;']);
      ld.define('element_end', ['>', '&gt;']);
      ld.define('list_unordered', ['- ', '  - ', '    - ', '      - ', '        - ', '          - ', '            - ']);
      ld.define('list_ordered', ['[0123456789][0123456789]. ', '[0123456789]. ', '  [0123456789]. ', '    [0123456789]. ', '      [0123456789]. ', '        [0123456789]. ', '          [0123456789]. ', '            [0123456789]. ']);
      ld.define('new_line', '\n');
      ld.defineText('table', '|', '|\n');
      ld.define('operator', ['+', '/', '=', '==', '===', '^', '!', '|', '||', '&', '&&']);
      ld.defineText('bold_italic', '***', '***');
      ld.defineText('bold', '**', '**', {
        escape: '*',
        escaped: {
          '*': '*'
        }
      });
      ld.defineText('image_link', '![', ')');
      ld.defineText('url_link', '<a ', '</a>');
      return ld;
    }; // CONCATENATED MODULE: ./src/parsers/block-quote/block-quote.tsx


    var BlockQuote = function BlockQuote() {
      return function (param) {
        var input = param.input,
            data = param.data,
            lex = param.lex;
        var obj;
        var replacements = [];

        while (obj = lex.next()) {
          var blockStart = void 0,
              blockEnd = void 0;

          if (obj.token === 'block') {
            // we need to check if previous is an element_end or \n
            var pos = lex.position();
            lex.seek(obj.begin - 1);
            var prevObj = lex.next();

            if ((prevObj === null || prevObj === void 0 ? void 0 : prevObj.token) === 'element_end' || (prevObj === null || prevObj === void 0 ? void 0 : prevObj.token) === 'new_line') {
              // restore position before we moved backwards
              blockStart = obj;
              lex.seek(pos);

              while (obj = lex.next()) {
                if (obj.token === 'new_line') {
                  blockEnd = obj;
                  break;
                }
              }
            } else {
              lex.seek(pos);
            }

            if (blockStart && blockEnd) {
              var value = input.substring(blockStart.end - 3, blockEnd.end).trim();

              if (value) {
                replacements.push({
                  searchValue: value,
                  replaceValue: "<blockquote style=\"background:#f9f9f9;border-left: 10px solid #ccc;margin: 1.5em 10px;padding: 1em 10px 1em 10px;\">".concat(input.substring(blockStart === null || blockStart === void 0 ? void 0 : blockStart.end, blockEnd === null || blockEnd === void 0 ? void 0 : blockEnd.end).trim(), "</blockquote>")
                });
              }
            }
          }
        }

        var _iteratorNormalCompletion = true,
            _didIteratorError = false,
            _iteratorError = undefined;

        try {
          for (var _iterator = replacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var rep = _step.value;
            input = input.replace(rep.searchValue, rep.replaceValue);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return {
          input: input,
          data: data,
          lex: lex
        };
      };
    }; // CONCATENATED MODULE: ./src/parsers/bold-italic/bold-italic.tsx


    var BoldItalic = function BoldItalic() {
      return function (param) {
        var input = param.input,
            lex = param.lex,
            data = param.data;
        var obj;
        var replacements = [];

        while (obj = lex.next()) {
          switch (obj.token) {
            case 'bold':
              replacements.push({
                searchValue: input.substring(obj.begin, obj.end + 1),
                replaceValue: "<b>".concat(obj.value, "</b>")
              });
              break;

            case 'bold_italic':
              replacements.push({
                searchValue: input.substring(obj.begin, obj.end + 1),
                replaceValue: "<b><i>".concat(obj.value, "</i></b>")
              });
              break;

            case 'italic':
              replacements.push({
                searchValue: input.substring(obj.begin, obj.end + 1),
                replaceValue: "<i>".concat(obj.value, "</i>")
              });
              break;
          }
        }

        var _iteratorNormalCompletion = true,
            _didIteratorError = false,
            _iteratorError = undefined;

        try {
          for (var _iterator = replacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var rep = _step.value;
            input = input.replace(rep.searchValue, rep.replaceValue);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        } // replace all *text* with regex
        // special case as * is used by the lexer, and it breaks when a single one is present


        var italicRegex = /[^\\]\*(.*?[^\/])\*/g;
        var match = input.match(italicRegex);

        if (match && match.length > 0) {
          var _iteratorNormalCompletion1 = true,
              _didIteratorError1 = false,
              _iteratorError1 = undefined;

          try {
            for (var _iterator1 = match[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true) {
              var ita = _step1.value; // check if charAt(0) == *, if not, move it over one

              if (ita.charAt(0) != '*') {
                ita = ita.substring(1);
              }

              input = input.replace(ita, "<i>".concat(ita.replace(/\*/g, ''), "</i>"));
            }
          } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
              }
            } finally {
              if (_didIteratorError1) {
                throw _iteratorError1;
              }
            }
          }
        } // replace escaped * (\*) with single * - another special case!


        input = input.replace(/\\\*/g, '*');
        return {
          input: input,
          lex: lex,
          data: data
        };
      };
    }; // CONCATENATED MODULE: ./src/parsers/headers/headers.tsx


    var headingRegex = /*#__PURE__*/_wrapRegExp(/(#+\s*)(.*)/i, {
      head: 1,
      heading: 2
    });

    var Headers = function Headers() {
      return function (param) {
        var input = param.input,
            lex = param.lex,
            data = param.data;
        var obj;
        var replacements = [];

        while (obj = lex.next()) {
          var headerStart = void 0,
              headerEnd = void 0;

          if (obj.token === 'header') {
            headerStart = obj;

            while (obj = lex.next()) {
              if (obj.token === 'new_line') {
                headerEnd = obj;
                break;
              }
            }

            var value = input.substring(headerStart === null || headerStart === void 0 ? void 0 : headerStart.begin, headerEnd === null || headerEnd === void 0 ? void 0 : headerEnd.end);

            if (value) {
              var ref;
              var match = value.match(headingRegex);
              var headerLength = match && (match === null || match === void 0 ? void 0 : (ref = match.groups) === null || ref === void 0 ? void 0 : ref.head.trim().length);
              var style = headerLength && headerLength > 2 ? 'margin-bottom:0px;' : null;
              replacements.push({
                searchValue: value,
                replaceValue: "<h".concat(headerLength).concat(style ? " style=".concat(style) : '', ">").concat(value.substring(headerLength || 0), "</h").concat(headerLength, ">")
              });
            }
          }
        }

        var _iteratorNormalCompletion = true,
            _didIteratorError = false,
            _iteratorError = undefined;

        try {
          for (var _iterator = replacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var rep = _step.value;
            input = input.replace(rep.searchValue, rep.replaceValue);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return {
          input: input,
          lex: lex,
          data: data
        };
      };
    }; // EXTERNAL MODULE: ./src/parsers/if-statement/if-statement.tsx


    var if_statement = __webpack_require__("./src/parsers/if-statement/if-statement.tsx"); // CONCATENATED MODULE: ./src/parsers/inline-image/inline-image.tsx


    var imageRegex = /*#__PURE__*/_wrapRegExp(/!\[([^\]]*)\]\((.*?)(?="|\))(?:"(.*)")?\)/, {
      alt: 1,
      url: 2,
      title: 3
    });

    var InlineImage = function InlineImage() {
      return function (param) {
        var input = param.input,
            lex = param.lex,
            data = param.data;
        var obj;
        var replacements = [];

        while (obj = lex.next()) {
          if (obj.token === 'image_link') {
            var value = input.substring(obj.begin, obj.end + 1).trim();

            if (value) {
              var match = value.match(imageRegex);

              if (match && match.length > 0) {
                var ref, ref1, ref2;
                replacements.push({
                  searchValue: value,
                  replaceValue: "<img src=\"".concat(match === null || match === void 0 ? void 0 : (ref = match.groups) === null || ref === void 0 ? void 0 : ref.url.trim(), "\" alt=\"").concat((match === null || match === void 0 ? void 0 : (ref1 = match.groups) === null || ref1 === void 0 ? void 0 : ref1.alt) || '', "\" title=\"").concat((match === null || match === void 0 ? void 0 : (ref2 = match.groups) === null || ref2 === void 0 ? void 0 : ref2.title) || '', "\" style=\"max-width:93%; width:auto;\" />")
                });
              }
            }
          }
        }

        var _iteratorNormalCompletion = true,
            _didIteratorError = false,
            _iteratorError = undefined;

        try {
          for (var _iterator = replacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var rep = _step.value;
            input = input.replace(rep.searchValue, rep.replaceValue);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return {
          input: input,
          lex: lex,
          data: data
        };
      };
    }; // CONCATENATED MODULE: ./src/parsers/mustache/mustache.tsx


    var Mustache = function Mustache() {
      return function (param) {
        var input = param.input,
            lex = param.lex,
            data = param.data;
        var obj; // list of all mustaches

        var mustacheReplacements = [];

        while (obj = lex.next()) {
          var mustacheStart = void 0,
              mustacheEnd = void 0; // {{ mustache_start

          if (obj.token === 'mustache_start') {
            var ref, ref1; // keep moving forward until we find mustache_end

            mustacheStart = obj;

            while (obj = lex.next()) {
              // }} mustache_end
              if (obj.token === 'mustache_end') {
                mustacheEnd = obj;
                break;
              }
            } // get the obj name inside of {{}}


            var mustacheValue = input.substring(mustacheStart.end + 1, mustacheEnd.begin); // replace value from data object

            var replacedMustacheValue = ((ref1 = (ref = mustacheValue === null || mustacheValue === void 0 ? void 0 : mustacheValue.trim()) === null || ref === void 0 ? void 0 : ref.split('.')) === null || ref1 === void 0 ? void 0 : ref1.reduce(function (o, i) {
              return o && o[i];
            }, data)) || ''; // construct the full mustache value

            var fullMustache = input.substring(mustacheStart.begin, mustacheEnd.end + 1);

            if (fullMustache) {
              mustacheReplacements.push({
                searchValue: fullMustache,
                replaceValue: replacedMustacheValue
              });
            }
          }
        }

        var _iteratorNormalCompletion = true,
            _didIteratorError = false,
            _iteratorError = undefined;

        try {
          // loop through each mustache value, and replace with data value
          for (var _iterator = mustacheReplacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var mr = _step.value;
            input = input.replace(new RegExp(mr.searchValue, 'gi'), mr.replaceValue);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return {
          input: input,
          lex: lex,
          data: data
        };
      };
    }; // EXTERNAL MODULE: ./src/utils/is-document/is-document.ts


    var is_document = __webpack_require__("./src/utils/is-document/is-document.ts"); // CONCATENATED MODULE: ./src/utils/add-css-class-body/add-css-class-body.ts


    var AddCssClassToBody = function AddCssClassToBody(css) {
      if (Object(is_document["a"
      /* IsDocumentDefined */
      ])() && css) {
        var ref;
        var sheet = document === null || document === void 0 ? void 0 : document.createElement('style');
        sheet.innerHTML = css;
        sheet.id = 'cvna-parser-css';
        document === null || document === void 0 ? void 0 : (ref = document.head) === null || ref === void 0 ? void 0 : ref.appendChild(sheet);
      }

      return true;
    }; // CONCATENATED MODULE: ./src/parsers/lists/lists.tsx


    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    function _objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);

        if (typeof Object.getOwnPropertySymbols === "function") {
          ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
          }));
        }

        ownKeys.forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      }

      return target;
    }

    var classAdded = false;

    var List = function List() {
      return function (param) {
        var input = param.input,
            data = param.data,
            lex = param.lex; // loop through and get the start of a list
        // we need to keep track from start to end of list section
        // once we have that, that is one list that we can replace within a range (start-> end)

        var obj; // keeps track of every list section (start of list to end of list)

        var listSections = [];
        var continuingList = 0;
        var listCounter = 0;

        while (obj = lex.next()) {
          var listStart = void 0,
              listEnd = void 0;

          if (obj.token === 'list_ordered' || obj.token === 'list_unordered') {
            // the current line has a list. keep looping until we find the end
            listStart = obj;

            while (obj = lex.next()) {
              if (obj.token === 'new_line' || obj.token === 'element_start') {
                // we found the end of the line, mark it
                listEnd = obj;
                break;
              }
            }
          }

          var listType = void 0; // if we have a dash, check if previous token is a new line. continue if it is
          // this is so we don't mark  "text - with dash" as a list

          var isPrevTokenNewLine = input.substring((listStart === null || listStart === void 0 ? void 0 : listStart.begin) - 1, listStart === null || listStart === void 0 ? void 0 : listStart.begin) === '\n' || (listStart === null || listStart === void 0 ? void 0 : listStart.begin) === 0;

          if (listStart && listEnd && isPrevTokenNewLine) {
            var searchValue = input.substring(listStart.begin, listEnd.begin);
            var value = input.substring(listStart.end, listEnd.begin).trim();
            var li = searchValue.trim().charAt(0).trim();
            listType = li === '-' ? 'ul' : 'ol';

            if (searchValue) {
              if (continuingList === 0) {
                var ref; // keep track of list section

                listSections[listCounter] = {
                  start: listStart.begin,
                  value: (((ref = listSections[listCounter]) === null || ref === void 0 ? void 0 : ref.value) || '') + "<".concat(listType, " class=\"cvna-parser-list\">")
                };
              }

              continuingList = 1;
              var howManySpaces = 0; // get start of `-`, and go backwards in the string
              // we're looking for the start of the line `\n`
              // and we count how many spaces between the `-` and the start of line `\n`
              // so we know how many indents we need to add to our list html

              for (var index = input.indexOf(li, listStart.begin); index > 0; index--) {
                if (input.substring(index).charAt(0) === '\n' || index === 1) {
                  break;
                } else if (input.substring(index).charAt(0) === ' ') {
                  howManySpaces++;
                }
              } // if we have spaces, the list item needs to be indented (wrapped in ol/ul)


              if (howManySpaces > 2) {
                var ref1;
                var startul = '';
                var endul = ''; // check for max spaces of 12 and don't do math

                var minusMath = howManySpaces === 12 ? 0 : 1;

                for (var i = 0; i < howManySpaces / 3 - minusMath; i++) {
                  startul = startul + "<".concat(listType, ">");
                  endul = endul + "</".concat(listType, ">");
                }

                listSections[listCounter] = _objectSpread({}, listSections[listCounter], {
                  value: ((ref1 = listSections[listCounter]) === null || ref1 === void 0 ? void 0 : ref1.value) + "".concat(startul, "<li> ").concat(value, "</li>").concat(endul)
                });
              } else {
                var ref2;
                listSections[listCounter] = _objectSpread({}, listSections[listCounter], {
                  value: ((ref2 = listSections[listCounter]) === null || ref2 === void 0 ? void 0 : ref2.value) + "<li> ".concat(value, "</li>")
                });
              }
            }
          } else {
            if (continuingList === 1) {
              var ref3, ref4, ref5; // if list section was started, end it and add to list counter

              listSections[listCounter] = _objectSpread({}, listSections[listCounter], {
                end: obj.begin,
                value: ((ref3 = listSections[listCounter]) === null || ref3 === void 0 ? void 0 : ref3.value) + "</".concat(listType || ((ref4 = listSections[listCounter]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.substring(1, 3)) || 'ul', ">")
              });
              listCounter++;
            }

            continuingList = 0;
          }
        }

        if (listSections.length > 0 && !classAdded) {
          // add special class to body so we can use css
          classAdded = AddCssClassToBody("\n      .cvna-parser-list {\n        margin-left: 0px;\n        margin-bottom: 0px;\n      }\n\n      .cvna-parser-list li::before {\n        margin-left: -20px;\n        margin-right: 10px;\n      }\n      ");
        }

        var newInput = input;

        for (var index1 = 0; index1 < listSections.length; index1++) {
          var _index = listSections[index1],
              _start = _index.start,
              start = _start === void 0 ? 0 : _start,
              _end = _index.end,
              end = _end === void 0 ? input.length : _end,
              value1 = _index.value;
          newInput = newInput.replace(input.substring(start, end - 1), value1);
        }

        return {
          input: newInput,
          data: data,
          lex: lex
        };
      };
    }; // EXTERNAL MODULE: ./src/utils/render-custom-component/render-custom-component.tsx


    var render_custom_component = __webpack_require__("./src/utils/render-custom-component/render-custom-component.tsx"); // EXTERNAL MODULE: ./src/utils/uuid/uuid.ts


    var uuid = __webpack_require__("./src/utils/uuid/uuid.ts"); // CONCATENATED MODULE: ./src/parsers/url-link/url-link.tsx


    var internal = function internal(to) {
      return to && !/\.[^\s]{2,}/.test(to);
    };

    var regex = /*#__PURE__*/_wrapRegExp(/\[([^\]]*)\]\((.*?)(?="|\))\)/i, {
      title: 1,
      url: 2
    });

    var regexAHrefHtmlElement = /*#__PURE__*/_wrapRegExp(/<a href=[\\]?"(.*?)[\\]?"(.*?)>(.*?)<\/a>/i, {
      url: 1,
      props: 2,
      title: 3
    });

    var url_link_classAdded = false;

    var addCss = function addCss() {
      if (!url_link_classAdded) {
        url_link_classAdded = AddCssClassToBody("\n    .cvna-parser-link {\n      text-decoration: underline;\n      color: var(--cvna-color-blue-2, #00B3D9);\n    }\n\n    .cvna-parser-link:hover {\n      color: var(--cvna-color-blue-2, #00B3D9);\n    }");
      }
    };

    var UrlLink = function UrlLink() {
      var ref4 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          customComponentWrapper = ref4.customComponentWrapper,
          urlComponents = ref4.urlComponents;
      return function (param) {
        var input = param.input,
            data = param.data,
            lex = param.lex;
        var newInput = input; // check for <a href /> links, and convert those over to components if needed

        if ((urlComponents === null || urlComponents === void 0 ? void 0 : urlComponents.internal) || (urlComponents === null || urlComponents === void 0 ? void 0 : urlComponents.external)) {
          addCss();
          var obj;

          while (obj = lex.next()) {
            if (obj.token === 'url_link') {
              var value = input.substring(obj.begin, obj.end + 1);
              var match = value.match(regexAHrefHtmlElement);

              if (match && (match === null || match === void 0 ? void 0 : match.length) > 0) {
                var ref;
                var ref1 = (match === null || match === void 0 ? void 0 : match.groups) || {},
                    url = ref1.url,
                    title = ref1.title,
                    props = ref1.props;
                var isInternalLink = internal(match === null || match === void 0 ? void 0 : (ref = match.groups) === null || ref === void 0 ? void 0 : ref.url);
                var Component = isInternalLink ? urlComponents === null || urlComponents === void 0 ? void 0 : urlComponents.internal : urlComponents === null || urlComponents === void 0 ? void 0 : urlComponents.external;

                if (Component) {
                  var id = "".concat(url, "-").concat(title, "-").concat(Object(uuid["a"
                  /* uuid */
                  ])());
                  newInput = newInput.replace(value, "<span id=\"".concat(id, "\"></span>"));
                  Object(render_custom_component["a"
                  /* RenderCustomComponent */
                  ])(customComponentWrapper, /*#__PURE__*/external_react_default.a.createElement(Component, {
                    url: url,
                    title: title,
                    props: props
                  }), id);
                }
              }
            }
          }
        }

        var linkMatches = newInput.match(new RegExp(regex, 'g'));

        if (linkMatches && linkMatches.length > 0) {
          addCss();
          var _iteratorNormalCompletion = true,
              _didIteratorError = false,
              _iteratorError = undefined;

          try {
            for (var _iterator = linkMatches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var link = _step.value;

              if (link && link.length > 0) {
                var ref2 = link.match(regex) || {},
                    tmp = ref2.groups,
                    ref3 = tmp === void 0 ? {
                  title: '',
                  url: ''
                } : tmp,
                    title1 = ref3.title,
                    url1 = ref3.url;

                if (url1 && title1) {
                  var isInternalLink1 = internal(url1);
                  var Component1 = isInternalLink1 ? urlComponents === null || urlComponents === void 0 ? void 0 : urlComponents.internal : urlComponents === null || urlComponents === void 0 ? void 0 : urlComponents.external;

                  if (Component1) {
                    var id1 = "".concat(url1, "-").concat(title1, "-").concat(Object(uuid["a"
                    /* uuid */
                    ])()); // we have a custom component, use that one

                    newInput = newInput.replace(link, "<span id=\"".concat(id1, "\"></span>"));
                    Object(render_custom_component["a"
                    /* RenderCustomComponent */
                    ])(customComponentWrapper, /*#__PURE__*/external_react_default.a.createElement(Component1, {
                      url: url1,
                      title: title1
                    }), id1);
                  } else {
                    var ahref = isInternalLink1 ? "<a class=\"cvna-parser-link\" href=\"".concat(url1, "\">").concat(title1, "</a>") : "<a class=\"cvna-parser-link\" href=\"".concat(url1, "\" target=\"_blank\" rel=\"noopener noreferrer\">").concat(title1, "</a>");
                    newInput = newInput.replace(link, ahref);
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        return {
          input: newInput,
          data: data,
          lex: lex
        };
      };
    }; // CONCATENATED MODULE: ./src/parsers/table/table.ts


    function table_defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    function table_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);

        if (typeof Object.getOwnPropertySymbols === "function") {
          ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
          }));
        }

        ownKeys.forEach(function (key) {
          table_defineProperty(target, key, source[key]);
        });
      }

      return target;
    }

    var tableClassAdded = false;

    var Table = function Table() {
      return function (param) {
        var _loop = function _loop(index2) {
          var table = tableSections[index2]; // build the table

          var stringBuilder = '';

          if (table.tableBuilder.Columns > 0 && table.tableBuilder.Head.length > 0 && table.tableBuilder.Alignment.length > 0 && table.tableBuilder.Body.length > 0) {
            stringBuilder += '<table class="cvna-parser-table" width="100%">'; // head

            stringBuilder += '<tr>';

            for (var index1 = 0; index1 < table.tableBuilder.Head.length; index1++) {
              var head = table.tableBuilder.Head[index1];
              var align = table.tableBuilder.Alignment[index1];
              stringBuilder += "<th class=\"".concat(align, "\">").concat(head, "</th>");
            }

            stringBuilder += '</tr>'; // body

            table.tableBuilder.Body.forEach(function (body) {
              stringBuilder += '<tr>';

              for (var index = 0; index < body.length; index++) {
                var row = body[index];
                var align = table.tableBuilder.Alignment[index];
                stringBuilder += "<td class=\"".concat(align, "\">").concat(row, "</td>");
              }

              stringBuilder += '</tr>';
            });
            stringBuilder += '</table>';
          }

          if (stringBuilder) {
            newInput = newInput.replace(input.substring(table.start, table.end - 1), stringBuilder).trim();
          }
        };

        var input = param.input,
            data = param.data,
            lex = param.lex;
        var obj;
        var continuingTable = false;
        var tableSections = [];
        var tableCounter = 0; // replace the start->end with table html

        while (obj = lex.next()) {
          if (obj.token === 'table') {
            var ref;

            if (!continuingTable) {
              continuingTable = true;
              tableSections[tableCounter] = {
                start: obj.begin,
                tableBuilder: {
                  Columns: 0,
                  Head: [],
                  Alignment: [],
                  Body: []
                }
              };
            }

            var value = input.substring(obj.begin + 1, obj.end - 1); // first row, that will always be header
            // second row will be -- with alignments (:---, :---:, ---:)
            // every row after the first two will be the body

            if (((ref = tableSections[tableCounter]) === null || ref === void 0 ? void 0 : ref.tableBuilder.Columns) === 0) {
              // this is our first row, count how many columns
              var splitOnPipe = value.split('|');
              tableSections[tableCounter].tableBuilder.Columns = splitOnPipe.length;
              tableSections[tableCounter].tableBuilder.Head = splitOnPipe.filter(function (x) {
                return x.trim();
              });
            } else if (tableSections[tableCounter].tableBuilder.Columns > 0 && tableSections[tableCounter].tableBuilder.Alignment.length === 0) {
              var _iteratorNormalCompletion = true,
                  _didIteratorError = false,
                  _iteratorError = undefined;

              try {
                // we're in the second row, get alignments
                for (var _iterator = value.split('|')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var iterator = _step.value;
                  var clean = iterator.trim();
                  var firstChar = clean.charAt(0);
                  var endChar = clean.charAt(clean.length - 1);

                  if (firstChar === ':' && endChar === ':') {
                    tableSections[tableCounter].tableBuilder.Alignment.push('center');
                  } else if (endChar === ':') {
                    tableSections[tableCounter].tableBuilder.Alignment.push('right');
                  } else {
                    tableSections[tableCounter].tableBuilder.Alignment.push('left');
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            } else if (tableSections[tableCounter].tableBuilder.Columns > 0 && tableSections[tableCounter].tableBuilder.Alignment.length > 0) {
              // the rest of rows
              var splitOnPipe1 = value.split('|');
              tableSections[tableCounter].tableBuilder.Body.push(splitOnPipe1);
            }
          } else {
            if (continuingTable) {
              continuingTable = false;
              tableSections[tableCounter] = table_objectSpread({}, tableSections[tableCounter], {
                end: obj.end
              });
              tableCounter++;
            }
          }
        }

        var newInput = input;

        for (var index2 = 0; index2 < tableSections.length; index2++) {
          _loop(index2);
        }

        if (!tableClassAdded) {
          tableClassAdded = AddCssClassToBody("\n      .cvna-parser-table td, .cvna-parser-table th {\n        border: 1px solid #dddddd;\n        text-align: left;\n        padding: 8px;\n      }\n      .cvna-parser-table .right {\n        text-align: right;\n      }\n      .cvna-parser-table .left {\n        text-align: left;\n      }\n      .cvna-parser-table .center {\n        text-align: center;\n      }\n      ");
        }

        return {
          input: newInput,
          data: data,
          lex: lex
        };
      };
    }; // EXTERNAL MODULE: ./src/parsers/custom-components/custom-components.tsx


    var custom_components = __webpack_require__("./src/parsers/custom-components/custom-components.tsx"); // CONCATENATED MODULE: ./src/index.tsx

    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "pipeWithLexer", function () {
      return pipeWithLexer;
    });
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "Parser", function () {
      return src_Parser;
    });

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }

    function src_defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    function src_objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);

        if (typeof Object.getOwnPropertySymbols === "function") {
          ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
          }));
        }

        ownKeys.forEach(function (key) {
          src_defineProperty(target, key, source[key]);
        });
      }

      return target;
    }

    var src_classAdded = false;

    var pipeWithLexer = function pipeWithLexer() {
      for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
        fns[_key] = arguments[_key];
      }

      return function (x) {
        var def = x.def;
        return fns.reduce(function (v, f) {
          var input = v.input;
          return f(src_objectSpread({}, v, {
            lex: def.lexer(input)
          }));
        }, x);
      };
    };

    var merge = function merge(a, b, prop) {
      var reduced = a.filter(function (aitem) {
        return !b.find(function (bitem) {
          return aitem[prop] === bitem[prop];
        });
      });
      return reduced.concat(b);
    };

    var addNewLineToEndOfString = function addNewLineToEndOfString(input) {
      return input + '\n\n';
    };

    var removeUnwantedHtml = function removeUnwantedHtml(input, customComponents) {
      var newInput = input; // With new toastui editor in strapi, custom components will need
      // to be surrounded by a code block (this is to support the strapi editor)
      // we need to remove that as it is not needed in our parser
      // the code block should look like:
      // <code data-backticks="1">&lt;UsStatesSelect /&gt;</code>
      // Create regex for each customcomponent that we have
      // that way we don't accidently grab a real code block

      customComponents === null || customComponents === void 0 ? void 0 : customComponents.forEach(function (param) {
        var name = param.name;
        var ref2;
        var codeComponentRegex = "(<code([^>]+)>)&lt;(?<value>".concat(name, ".*?) /&gt;(<([^>]+)code>)");
        (ref2 = input === null || input === void 0 ? void 0 : input.match(new RegExp(codeComponentRegex, 'gi'))) === null || ref2 === void 0 ? void 0 : ref2.forEach(function (m) {
          var ref;
          var matched = m.match(new RegExp(codeComponentRegex, 'i'));

          if (matched && (matched === null || matched === void 0 ? void 0 : matched.length) > 0 && (matched === null || matched === void 0 ? void 0 : (ref = matched.groups) === null || ref === void 0 ? void 0 : ref.value)) {
            var ref1;
            newInput = newInput.replace(m, "<".concat(matched === null || matched === void 0 ? void 0 : (ref1 = matched.groups) === null || ref1 === void 0 ? void 0 : ref1.value, " />"));
          }
        });
      });
      return newInput;
    };

    var src_Parser = /*#__PURE__*/function () {
      "use strict";

      function Parser(options) {
        _classCallCheck(this, Parser);

        this.ref = /*#__PURE__*/external_react_default.a.createRef();
        this.options = options || {};
        this.lexer = Definitions(); // add css to head

        if (!src_classAdded) {
          src_classAdded = AddCssClassToBody("\n      /* table */\n      #cvna-parser table {\n        border: 1px solid rgba(0, 0, 0, 0.1);\n        margin: 12px 0 14px;\n        color: #222;\n        width: auto;\n        border-collapse: collapse;\n        box-sizing: border-box;\n      }\n\n      #cvna-parser table th {\n        font-weight: 300;\n        padding-top: 6px;\n      }\n\n      #cvna-parser td,\n      #cvna-parser th {\n        border: 1px solid #dddddd;\n        text-align: left;\n        padding: 5px 14px 5px 12px;\n        height: 32px;\n      }\n\n      #cvna-parser td[align=\"right\"], \n      #cvna-parser th[align=\"right\"] {\n        text-align: right;\n      }\n\n      #cvna-parser td[align=\"left\"],\n      #cvna-parser th[align=\"left\"] {\n        text-align: left;\n      }\n      \n      #cvna-parser td[align=\"center\"],\n      #cvna-parser th[align=\"center\"] {\n        text-align: center;\n      }\n\n      /* list */\n      #cvna-parser li {\n        margin-left: 0px;\n        margin-bottom: 0px;\n      }\n\n      #cvna-parser li::before {\n        margin-left: -20px;\n        margin-right: 10px;\n      }\n\n      #cvna-parser ul p, \n      #cvna-parser ol p {\n        margin: 0;\n      }\n\n      /* link */\n      #cvna-parser a {\n        text-decoration: underline;\n        color: var(--cvna-color-blue-2, #00B3D9);\n      }\n\n      #cvna-parser a:hover {\n        color: var(--cvna-color-blue-2, #00B3D9);\n      }\n\n      /* blockquote */\n      #cvna-parser blockquote {\n        background:#f9f9f9;\n        border-left: 10px solid #ccc;\n        margin: 1.5em 10px;\n        padding: 1em 10px 1em 10px;\n      }\n\n      #cvna-parser .ProseMirror-trailingBreak {\n        display: none;\n      }\n\n      /* inline code */\n      #cvna-parser code {\n        padding: 0.2rem 0.5rem;\n        margin: 0 0.2rem;\n        font-size: 90%;\n        background: #F1F1F1;\n        border: 1px solid #E1E1E1;\n        border-radius: 4px;\n      }\n\n      /* code block */\n      #cvna-parser pre > code {\n        display: block;\n        background: #F1F1F1;\n        border: 1px solid #E1E1E1;\n        border-radius: 4px;\n        font-size: 90%;\n        padding: 0.2rem 0.5rem;\n      }\n\n      /* image */\n      #cvna-parser img {\n        max-width:93%; \n        width:auto;\n      }\n      ");
        }
      }

      _createClass(Parser, [{
        key: "addCustomComponents",
        value: function addCustomComponents(cc) {
          var ref;
          this.options = src_objectSpread({}, this.options, {
            customComponents: merge((ref = this.options) === null || ref === void 0 ? void 0 : ref.customComponents, cc, 'name')
          });
        }
      }, {
        key: "addUrlComponents",
        value: function addUrlComponents(uc) {
          var ref;
          this.options = src_objectSpread({}, this.options, {
            urlComponents: src_objectSpread({}, (ref = this.options) === null || ref === void 0 ? void 0 : ref.urlComponents, uc)
          });
        }
      }, {
        key: "render",
        value: function render(input, data, cb) {
          var ref;
          if (!input) return null; // add \n to end of article if one does not exist

          var inputString = addNewLineToEndOfString(input); // do some cleanup of unwanted html code from editor

          inputString = removeUnwantedHtml(inputString, (ref = this.options) === null || ref === void 0 ? void 0 : ref.customComponents);
          var result = {
            input: inputString
          };

          try {
            var ref3, ref4, ref5, ref6, ref7;
            result = pipeWithLexer(Object(if_statement["a"
            /* IfStatement */
            ])(), Mustache(), Table(), List(), BoldItalic(), Headers(), InlineImage(), BlockQuote(), UrlLink({
              customComponentWrapper: (ref3 = this.options) === null || ref3 === void 0 ? void 0 : ref3.customComponentWrapper,
              urlComponents: (ref4 = this.options) === null || ref4 === void 0 ? void 0 : ref4.urlComponents
            }), Object(custom_components["a"
            /* CustomComponent */
            ])({
              customComponentWrapper: (ref5 = this.options) === null || ref5 === void 0 ? void 0 : ref5.customComponentWrapper,
              customComponents: (ref6 = this.options) === null || ref6 === void 0 ? void 0 : ref6.customComponents,
              cb: cb,
              env: (ref7 = this.options) === null || ref7 === void 0 ? void 0 : ref7.env
            }))({
              input: inputString,
              data: data,
              def: this.lexer
            });
          } catch (error) {
            console.error(error);
          }

          return /*#__PURE__*/external_react_default.a.createElement("div", {
            ref: this.ref.current,
            id: "cvna-parser",
            dangerouslySetInnerHTML: {
              __html: result.input
            },
            style: {
              whiteSpace: 'pre-line'
            }
          });
        }
      }]);

      return Parser;
    }();
    /***/

  },

  /***/
  "./src/lexer/lexer.js":
  /***/
  function srcLexerLexerJs(module, exports, __webpack_require__) {
    // taken from https://github.com/ajlopez/gelex
    // removed skip spaces functions as they are not configurable.
    var scanners = __webpack_require__("./src/lexer/scanner.js");

    function isManyExpression(expr) {
      return expr.length > 1 && expr[expr.length - 1] === '*';
    }

    function CommentRule(start, end) {
      this.first = function () {
        return start[0];
      };

      this.match = function (scanner) {
        if (scanner.peek(start.length) !== start) return null;
        scanner.seek(scanner.position() + start.length);

        while (scanner.peek(end.length) !== end) {
          if (!scanner.scan()) break;
        }

        if (scanner.peek(end.length) === end) scanner.seek(scanner.position() + end.length);
        return start + end;
      };
    }

    function LineCommentRule(start) {
      this.first = function () {
        return start[0];
      };

      this.match = function (scanner) {
        if (scanner.peek(start.length) !== start) return null;
        scanner.seek(scanner.position() + start.length);
        var ch;

        for (var ch1 = scanner.peek(1); ch1 != '\n' && ch1 != '\r'; ch1 = scanner.peek(1)) {
          if (!scanner.scan()) break;
        }

        return start;
      };
    }

    function AndRule(rules) {
      this.first = function () {
        return rules[0].first();
      };

      this.match = function (scanner) {
        var result = '';
        var begin = scanner.position();

        for (var n = 0; n < rules.length; n++) {
          var rule = rules[n];
          var value = rule.match(scanner);

          if (value == null) {
            scanner.seek(begin);
            return null;
          }

          result += value;
        }

        return result;
      };
    }

    function OrRule(rules) {
      this.first = function () {
        var result = '';

        for (var k = 0; k < rules.length; k++) {
          result += rules[k].first();
        }

        return result;
      };

      this.match = function (scanner) {
        var begin = scanner.position();
        var result = null;
        var resultend;

        for (var n = 0; n < rules.length; n++) {
          scanner.seek(begin);
          var rule = rules[n];
          var value = rule.match(scanner);
          if (!value) continue;

          if (!result || result.length < value.length) {
            result = value;
            resultend = scanner.position();
          }
        }

        if (result) {
          scanner.seek(resultend);
          return result;
        }

        scanner.seek(begin);
        return null;
      };
    }

    function TransformRule(rule, trfn) {
      this.first = function () {
        return rule.first();
      };

      this.match = function (scanner) {
        var result = rule.match(scanner);
        if (result == null) return null;
        if (trfn) return trfn(result);
        return result;
      };
    }

    function ManyRule(rule) {
      this.first = function () {
        return rule.first();
      };

      this.match = function (scanner) {
        var begin = scanner.position();
        var value = '';
        var result;

        while (result = rule.match(scanner)) {
          value += result;
        }

        return value;
      };
    }

    function CharRule(data) {
      this.first = function () {
        return data;
      };

      this.match = function (scanner) {
        var begin = scanner.position();
        var ch = scanner.scan();
        if (data.indexOf(ch) >= 0) return ch;
        scanner.seek(begin);
        return null;
      };
    }

    function RangeRule(from, to) {
      this.first = function () {
        var result = '';
        var fromvalue = from.charCodeAt(0);
        var tovalue = to.charCodeAt(0);

        for (var k = fromvalue; k <= tovalue; k++) {
          result += String.fromCharCode(k);
        }

        return result;
      };

      this.match = function (scanner) {
        var begin = scanner.position();
        var ch = scanner.scan();
        if (ch >= from && ch <= to) return ch;
        scanner.seek(begin);
        return null;
      };
    }

    function TextRule(start, end, options) {
      options = options || {};

      this.first = function () {
        return start[0];
      };

      this.match = function (scanner) {
        if (scanner.peek(start.length) !== start) return null;
        scanner.seek(scanner.position() + start.length);
        var result = '';

        while (scanner.peek(end.length) !== end) {
          var ch = scanner.scan();
          if (!ch) break;

          if (ch === options.escape) {
            ch = scanner.scan();
            if (options.escaped && options.escaped[ch]) result += options.escaped[ch];else result += ch;
            continue;
          }

          result += ch;
        }

        if (scanner.peek(end.length) === end) scanner.seek(scanner.position() + end.length);else throw new Error('unclosed text');
        return result;
      };
    }

    function LexerDefinition() {
      var createOrRule = function createOrRule(data) {
        if (data === '.') return new RangeRule(String.fromCharCode(0), String.fromCharCode(255));
        var rules = [];

        while (data.length) {
          if (data[1] === '-') {
            var from = data[0];
            var to = data[2];
            data = data.substring(3);
            rules.push(new RangeRule(from, to));
          } else {
            rules.push(new CharRule(data));
            data = '';
          }
        }

        if (rules.length === 0) return null;
        if (rules.length === 1) return rules[0];
        return new OrRule(rules);
      };

      var createRule = function createRule(data, trfn) {
        var rules = [];

        while (data.length) {
          if (data[0] === '[' && data.indexOf(']') > 0) {
            var p = data.indexOf(']');
            var subdata = data.substring(1, p);
            var rule = createOrRule(subdata);
            data = data.substring(p + 1);
            rules.push(rule);
          } else if (data[0] === '*' && rules.length) {
            rules[rules.length - 1] = new ManyRule(rules[rules.length - 1]);
            data = data.substring(1);
          } else {
            var rule1 = new CharRule(data[0]);
            data = data.substring(1);
            rules.push(rule1);
          }
        }

        if (rules.length === 0) return null;
        if (rules.length === 1) if (trfn) return new TransformRule(rules[0], trfn);else return rules[0];
        if (trfn) return new TransformRule(new AndRule(rules), trfn);else return new AndRule(rules);
      };

      var addRuleChar = function addRuleChar(name, rule, ch) {
        if (!rules1[ch]) {
          rules1[ch] = [{
            name: name,
            rule: rule
          }];
          return;
        }

        for (var k = 0; k < rules1[ch].length; k++) {
          if (rules1[ch][k].rule === rule) return;
        }

        rules1[ch].push({
          name: name,
          rule: rule
        });
      };

      var addRule = function addRule(name, rule) {
        var first = rule.first();

        for (var k = 0; k < first.length; k++) {
          addRuleChar(name, rule, first[k]);
        }
      };

      var rules1 = {};
      var commentRules = [];

      this.define = function (name, data, trfn) {
        if (Array.isArray(data)) for (var k = 0; k < data.length; k++) {
          addRule(name, createRule(data[k], trfn));
        } else if (typeof data === 'object') addRule(name, data);else addRule(name, createRule(data, trfn));
      };

      this.defineText = function (name, start, end, options) {
        addRule(name, new TextRule(start, end, options));
      };

      this.defineComment = function (start, end) {
        if (!end) commentRules.push(new LineCommentRule(start));else commentRules.push(new CommentRule(start, end));
      };

      this.lexer = function (text) {
        return new Lexer(text, rules1, commentRules);
      };
    }

    function Lexer(text, rules, commentRules) {
      var scanner = scanners.scanner(text);

      this.position = function () {
        return scanner.position();
      };

      this.seek = function (newposition) {
        scanner.seek(newposition);
      };

      this.char = function (ch) {
        var firstch = scanner.peek();

        if (firstch === ch) {
          var position = scanner.position();
          var ch2 = scanner.scan();
          return {
            token: 'char',
            value: ch2,
            begin: position,
            end: position
          };
        }

        return null;
      };

      this.next = function () {
        var firstch = scanner.peek();
        if (!firstch) return null;
        var begin = scanner.position();

        if (!rules[firstch]) {
          var ch = scanner.scan();
          return {
            token: 'unknown',
            value: ch,
            begin: begin,
            end: begin
          };
        }

        var token = null;
        var chrules = rules[firstch];

        for (var n in chrules) {
          scanner.seek(begin);
          var rule = chrules[n];
          var value = rule.rule.match(scanner);
          if (value === null) continue;
          var newtoken = {
            token: rule.name,
            value: value,
            begin: begin,
            end: scanner.position() - 1
          };
          if (!token || token.value.length < newtoken.value.length) token = newtoken;
        }

        if (token) {
          scanner.seek(token.end + 1);
          return token;
        }

        scanner.seek(begin);
        var ch3 = scanner.scan();
        return {
          token: 'unknown',
          value: ch3,
          begin: begin,
          end: begin
        };
      };
    }

    module.exports = {
      definition: function definition() {
        return new LexerDefinition();
      }
    };
    /***/
  },

  /***/
  "./src/lexer/scanner.js":
  /***/
  function srcLexerScannerJs(module, exports) {
    function Scanner(text) {
      var l = text ? text.length : 0;
      var p = 0;

      this.position = function () {
        return p;
      };

      this.seek = function (newp) {
        p = newp;
      };

      this.peek = function (length) {
        if (p >= l) return null;
        if (length) return text.substring(p, p + length);
        return text[p];
      };

      this.scan = function () {
        if (p >= l) return null;
        return text[p++];
      };
    }

    function createScanner(text) {
      return new Scanner(text);
    }

    module.exports = {
      scanner: createScanner
    };
    /***/
  },

  /***/
  "./src/parsers/custom-components/custom-components.tsx":
  /***/
  function srcParsersCustomComponentsCustomComponentsTsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";
    /* harmony export (binding) */

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return CustomComponent;
    });
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var _utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/uuid/uuid.ts");
    /* harmony import */


    var _utils_render_custom_component_render_custom_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/render-custom-component/render-custom-component.tsx");

    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;

      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    }

    function _arrayWithHoles(arr) {
      if (Array.isArray(arr)) return arr;
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    function _extends() {
      _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      return _extends.apply(this, arguments);
    }

    function _iterableToArrayLimit(arr, i) {
      var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

      if (_i == null) return;
      var _arr = [];
      var _n = true;
      var _d = false;

      var _s, _e;

      try {
        for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"] != null) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    function _objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);

        if (typeof Object.getOwnPropertySymbols === "function") {
          ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
          }));
        }

        ownKeys.forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      }

      return target;
    }

    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }

    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(n);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }

    var CustomComponent = function CustomComponent() {
      var ref1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {},
          customComponentWrapper = ref1.customComponentWrapper,
          customComponents = ref1.customComponents,
          cb = ref1.cb,
          env = ref1.env;
      return function (param) {
        var input = param.input,
            data = param.data,
            lex = param.lex; //  check to see if we have any custom components passed in

        if (customComponents && customComponents.length > 0) {
          var obj;
          var replacements = [];

          while (obj = lex.next()) {
            var customComponentStart = void 0,
                customComponentEnd = void 0,
                customComponent = void 0; // check if we are at element_start

            if (obj.token === 'element_start') {
              // move to the next one, and see if it matches a custom component
              obj = lex.next();

              if (obj.token === 'string' && obj.value) {
                // check to see if value exists in custom components array
                customComponent = customComponents.find(function (x) {
                  return x.name === obj.value;
                });

                if (customComponent) {
                  customComponentStart = obj; // we have a match keep looping until we get to element_end

                  while (obj = lex.next()) {
                    if (obj.token === 'element_end') {
                      customComponentEnd = obj;
                      break;
                    }
                  }
                }
              }
            }

            if (customComponentStart && customComponentEnd && customComponent) {
              var id = (customComponent === null || customComponent === void 0 ? void 0 : customComponent.name) || Object(_utils_uuid_uuid__WEBPACK_IMPORTED_MODULE_1__[
              /* uuid */
              "a"])(); // check input string if it starts with < OR &lt;

              var isLessThanHtmlCode = input.substring(customComponentStart.begin - 1, customComponentStart.begin) !== '<';
              var fullComponent = input.substring(customComponentStart.begin - (isLessThanHtmlCode ? 4 : 1), customComponentEnd.end + 1);
              var props = input.substring(customComponentStart.end + 1, customComponentEnd.begin - 1).trim().split(' ').reduce(function (prev, curr) {
                var ref = _slicedToArray(curr.split('='), 2),
                    key = ref[0],
                    value = ref[1];

                return _objectSpread({}, prev, _defineProperty({}, key, eval(value)));
              }, {});
              var CustomComponent1 = customComponent.component;

              if (CustomComponent1) {
                var Component = typeof CustomComponent1 === 'function' ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(CustomComponent1, _extends({
                  data: data,
                  cb: cb,
                  env: env
                }, props)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.cloneElement(CustomComponent1, _objectSpread({
                  data: data
                }, props));
                replacements.push({
                  searchValue: fullComponent,
                  replaceValue: Component,
                  id: id
                });
              } else {
                replacements.push({
                  searchValue: fullComponent,
                  replaceValue: '',
                  id: id
                });
              }
            }
          }

          var _iteratorNormalCompletion = true,
              _didIteratorError = false,
              _iteratorError = undefined;

          try {
            for (var _iterator = replacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var rep = _step.value;

              if (rep.replaceValue) {
                input = input.replace(rep.searchValue, "<span id=\"".concat(rep.id, "\"></span>"));
                Object(_utils_render_custom_component_render_custom_component__WEBPACK_IMPORTED_MODULE_2__[
                /* RenderCustomComponent */
                "a"])(customComponentWrapper, rep.replaceValue, rep.id);
              } else {
                input = input.replace(rep.searchValue, rep.replaceValue);
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        return {
          input: input,
          data: data,
          lex: lex
        };
      };
    };
    /***/

  },

  /***/
  "./src/parsers/if-statement/if-statement.tsx":
  /***/
  function srcParsersIfStatementIfStatementTsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";
    /* harmony export (binding) */

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return IfStatement;
    });
    /* harmony import */


    var _utils_is_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/utils/is-string/index.ts");

    var IfStatement = function IfStatement() {
      return function (param) {
        var input = param.input,
            lex = param.lex,
            data = param.data;
        var obj;
        var ifSections = [];
        var ifPos; // get all if statement sections

        while (obj = lex.next()) {
          if (obj.token === 'if_start') {
            if (ifPos === undefined) {
              // this is our first if_start, mark it!
              ifPos = obj;
            } else if (ifPos !== undefined) {
              // we previously had an if_start, add that one to the list
              ifSections.push({
                start: ifPos.begin,
                end: obj.begin - 1
              });
              ifPos = obj;
            }
          } else if (obj.token === 'if_end') {
            ifSections.push({
              start: ifPos.begin,
              end: obj.end
            });
            break;
          }
        }

        if (ifSections.length === 0) return {
          input: input,
          lex: lex,
          data: data
        };
        var _iteratorNormalCompletion = true,
            _didIteratorError = false,
            _iteratorError = undefined;

        try {
          var _loop = function _loop(_iterator, _step) {
            var ifSection = _step.value;
            var ref, ref1, ref2; // get start/end of if section

            var start = ifSection.start,
                end = ifSection.end; // reset scanner to start of if section

            lex.seek(start);
            var ifStartBegin = void 0,
                ifStartEnd = void 0;

            while (obj = lex.next()) {
              // mark start of {{#if
              if (obj.token === 'if_start' && ifStartBegin === undefined) ifStartBegin = obj.end; // mark end of }}

              if (obj.token === 'mustache_end' && ifStartEnd === undefined) ifStartEnd = obj.begin; // stop once we get to end of if section

              if (obj.end === end) break;
            } // build the if statement


            var ifStatement = input.substring(ifStartBegin, ifStartEnd).trim(); // check if if statement has `default`

            var isDefault = ifStatement === 'default'; // where {{#if starts

            ifSection.ifStatementStart = ifStartBegin; // where }} ends

            ifSection.ifStatementEnd = ifStartEnd; // full if statement

            ifSection.statement = ifStatement;
            ifSection.isDefault = isDefault; // if isdefault no further eval needed

            if (ifSection.isDefault) return "continue"; // eval statements and see if we have a match
            // split ifStatement into 3 sections
            // left = data object name
            // middle = operator
            // right = value it should equal

            var splitIfStatement = ifStatement.split(' ');
            var leftStatementReplacedByData = (ref2 = (ref1 = (ref = splitIfStatement[0]) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref1 === void 0 ? void 0 : ref1.split('.')) === null || ref2 === void 0 ? void 0 : ref2.reduce(function (o, i) {
              return o && o[i];
            }, data);
            leftStatementReplacedByData = Object(_utils_is_string__WEBPACK_IMPORTED_MODULE_0__[
            /* isString */
            "a"])(leftStatementReplacedByData) ? "\"".concat(leftStatementReplacedByData, "\"") : leftStatementReplacedByData;
            var isIfStatementTrue = eval("".concat(leftStatementReplacedByData, " ").concat(splitIfStatement[1], " ").concat(splitIfStatement[2]));
            ifSection.isIfStatementTrue = isIfStatementTrue; // if ifstatement is true, don't process remaining if sections

            if (isIfStatementTrue) return "break";
          }; // loop through each if section, and start doing math


          for (var _iterator = ifSections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ret = _loop(_iterator, _step);

            switch (_ret) {
              case "break":
                break;

              case "continue":
                continue;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        } // get true if section, or default section


        var ifStatementResult = ifSections.find(function (x) {
          return x.isIfStatementTrue;
        }) || ifSections.find(function (x) {
          return x.isDefault;
        });
        var ifStart = ifSections[0].start;
        var ifEnd = ifSections[ifSections.length - 1].end; // if no if statements matched, then remove all of {{#if}} {{/if}} statement

        if (!ifStatementResult) {
          return {
            input: input.replace(input.substring(ifStart, ifEnd + 1), ''),
            lex: lex,
            data: data
          };
        } // replace if statements


        var ifSectionReplaced = input.substring(ifStatementResult.start, ifStatementResult.end + 1);
        ifSectionReplaced = ifSectionReplaced.replace('{{/if}}', '');
        ifSectionReplaced = ifSectionReplaced.replace(input.substring(ifStatementResult.start || 0, (ifStatementResult.ifStatementEnd || 0) + 2), '');
        var finalResult = input.replace(input.substring(ifStart, ifEnd + 1), ifSectionReplaced).trim() + '\n';
        return {
          input: finalResult,
          lex: lex,
          data: data
        };
      };
    };
    /***/

  },

  /***/
  "./src/support-center-parser.tsx":
  /***/
  function srcSupportCenterParserTsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony export (binding) */


    __webpack_require__.d(__webpack_exports__, "SupportCenterParser", function () {
      return SupportCenterParser;
    });
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("styled-components");
    /* harmony import */


    var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */


    var _carvana_showroom_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("@carvana/showroom-theme");
    /* harmony import */


    var _carvana_showroom_theme__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_carvana_showroom_theme__WEBPACK_IMPORTED_MODULE_2__);
    /* harmony import */


    var _carvana_core_delivery_or_pickup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("@carvana/core-delivery-or-pickup");
    /* harmony import */


    var _carvana_core_delivery_or_pickup__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_carvana_core_delivery_or_pickup__WEBPACK_IMPORTED_MODULE_3__);
    /* harmony import */


    var _carvana_showroom_forms_Select_UsStatesSelect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("@carvana/showroom-forms/Select/UsStatesSelect");
    /* harmony import */


    var _carvana_showroom_forms_Select_UsStatesSelect__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_carvana_showroom_forms_Select_UsStatesSelect__WEBPACK_IMPORTED_MODULE_4__);
    /* harmony import */


    var _src__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/index.tsx");

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    function _objectSpread(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);

        if (typeof Object.getOwnPropertySymbols === "function") {
          ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
          }));
        }

        ownKeys.forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      }

      return target;
    }

    function _taggedTemplateLiteral(strings, raw) {
      if (!raw) {
        raw = strings.slice(0);
      }

      return Object.freeze(Object.defineProperties(strings, {
        raw: {
          value: Object.freeze(raw)
        }
      }));
    }

    function _templateObject() {
      var data = _taggedTemplateLiteral(["\n    > div:nth-child(1) {\n      text-align: left;\n    }\n  "]);

      _templateObject = function _templateObject() {
        return data;
      };

      return data;
    }

    var DeliveryOrPickupComponent = function DeliveryOrPickupComponent(props) {
      var key = props.key,
          cb = props.cb,
          data = props.data,
          env = props.env;
      var ref5 = data || {},
          tmp = ref5.user,
          ref1 = tmp === void 0 ? {} : tmp,
          _accessToken = ref1.accessToken,
          accessToken = _accessToken === void 0 ? '' : _accessToken,
          externalData = ref5.externalData;
      var DeliveryOrPickupCallback = (cb || {}).DeliveryOrPickupCallback;
      var DeliveryOrPickupWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1___default()(_carvana_core_delivery_or_pickup__WEBPACK_IMPORTED_MODULE_3___default.a)(_templateObject()); // this callback function calls the setExternalData function from article-content
      // which will update externalData state, and can be used to pass in data from external component

      var callback = function callback(resp) {
        var ref, ref2, ref3, ref4;
        DeliveryOrPickupCallback && DeliveryOrPickupCallback({
          user: {
            isOutOfMarket: resp === null || resp === void 0 ? void 0 : (ref = resp.soonestDeliveryAvailable) === null || ref === void 0 ? void 0 : ref.isThirdPartyDelivery,
            city: resp === null || resp === void 0 ? void 0 : (ref2 = resp.userLocation) === null || ref2 === void 0 ? void 0 : ref2.city,
            state: resp === null || resp === void 0 ? void 0 : (ref3 = resp.userLocation) === null || ref3 === void 0 ? void 0 : ref3.state,
            zip5: resp === null || resp === void 0 ? void 0 : (ref4 = resp.userLocation) === null || ref4 === void 0 ? void 0 : ref4.zip5
          },
          externalData: resp
        });
      };

      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(DeliveryOrPickupWrapper, {
        userAccessToken: accessToken,
        env: env || 'test',
        key: key,
        cb: callback,
        showCaption: false,
        data: externalData
      });
    };

    var UsStateSelectComponent = function UsStateSelectComponent(props) {
      var ref, ref6;
      var ref7 = props || {},
          data = ref7.data,
          cb = ref7.cb;
      var UsStatesSelectCallback = (cb || {}).UsStatesSelectCallback;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
        style: {
          width: '327px'
        }
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_carvana_showroom_forms_Select_UsStatesSelect__WEBPACK_IMPORTED_MODULE_4___default.a, {
        id: "us-states-select",
        onChange: function onChange(e) {
          UsStatesSelectCallback && UsStatesSelectCallback(e.target.value);
        },
        value: data === null || data === void 0 ? void 0 : (ref = data.user) === null || ref === void 0 ? void 0 : (ref6 = ref.state) === null || ref6 === void 0 ? void 0 : ref6.toUpperCase()
      }));
    };

    var SupportCenterParser = function SupportCenterParser() {
      var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        env: 'test'
      },
          _env = ref.env,
          env = _env === void 0 ? 'test' : _env;
      var GlobalStyles = Object(_carvana_showroom_theme__WEBPACK_IMPORTED_MODULE_2__["createGlobalStyle"])(env, null);
      return new _src__WEBPACK_IMPORTED_MODULE_5__["Parser"]({
        customComponentWrapper: function customComponentWrapper(param) {
          var children = param.children;
          /*#__PURE__*/

          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_carvana_showroom_theme__WEBPACK_IMPORTED_MODULE_2___default.a, {
            theme: _objectSpread({}, _carvana_showroom_theme__WEBPACK_IMPORTED_MODULE_2__["CarvanaThemeDeprecated"], _carvana_showroom_theme__WEBPACK_IMPORTED_MODULE_2__["CarvanaTheme"])
          }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(GlobalStyles, null), children);
        },
        customComponents: [{
          name: 'DeliveryOrPickup',
          component: DeliveryOrPickupComponent
        }, {
          name: 'UsStatesSelect',
          component: UsStateSelectComponent
        }],
        env: env
      });
    };
    /***/

  },

  /***/
  "./src/utils/is-document/is-document.ts":
  /***/
  function srcUtilsIsDocumentIsDocumentTs(module, __webpack_exports__, __webpack_require__) {
    "use strict";
    /* harmony export (binding) */

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return IsDocumentDefined;
    });

    var IsDocumentDefined = function IsDocumentDefined() {
      return typeof document !== "undefined";
    };
    /***/

  },

  /***/
  "./src/utils/is-string/index.ts":
  /***/
  function srcUtilsIsStringIndexTs(module, __webpack_exports__, __webpack_require__) {
    "use strict";
    /* harmony export (binding) */

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return isString;
    });

    var isString = function isString(s) {
      return typeof s === 'string';
    };
    /***/

  },

  /***/
  "./src/utils/render-custom-component/render-custom-component.tsx":
  /***/
  function srcUtilsRenderCustomComponentRenderCustomComponentTsx(module, __webpack_exports__, __webpack_require__) {
    "use strict";
    /* harmony export (binding) */

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return RenderCustomComponent;
    });
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("react");
    /* harmony import */


    var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */


    var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("react-dom");
    /* harmony import */


    var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */


    var _is_document_is_document__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/utils/is-document/is-document.ts");

    var DefaultWrapper = function DefaultWrapper(param) {
      var children = param.children;
      /*#__PURE__*/

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null, children);
    };

    var RenderCustomComponent = function RenderCustomComponent() {
      var Wrapper = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DefaultWrapper,
          Child = arguments.length > 1 ? arguments[1] : void 0,
          id = arguments.length > 2 ? arguments[2] : void 0;
      setTimeout(function () {
        if (Object(_is_document_is_document__WEBPACK_IMPORTED_MODULE_2__[
        /* IsDocumentDefined */
        "a"])()) {
          var elementId = document.getElementById(id);
          if (elementId) react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.render( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Wrapper, null, Child), elementId);
        }
      }, 100);
    };
    /***/

  },

  /***/
  "./src/utils/uuid/uuid.ts":
  /***/
  function srcUtilsUuidUuidTs(module, __webpack_exports__, __webpack_require__) {
    "use strict";
    /* harmony export (binding) */

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return uuid;
    });

    var uuid = function uuid() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '';
      return a ? ((Number(a) ^ Math.random() * 16) >> Number(a) / 4).toString(16) : "".concat(10000000, "-", 1000, "-", 4000, "-", 8000, "-", 100000000000).replace(/[018]/g, uuid);
    };
    /***/

  },

  /***/
  "@carvana/core-delivery-or-pickup":
  /***/
  function carvanaCoreDeliveryOrPickup(module, exports) {
    module.exports = require("@carvana/core-delivery-or-pickup");
    /***/
  },

  /***/
  "@carvana/showroom-forms/Select/UsStatesSelect":
  /***/
  function carvanaShowroomFormsSelectUsStatesSelect(module, exports) {
    module.exports = require("@carvana/showroom-forms/Select/UsStatesSelect");
    /***/
  },

  /***/
  "@carvana/showroom-theme":
  /***/
  function carvanaShowroomTheme(module, exports) {
    module.exports = require("@carvana/showroom-theme");
    /***/
  },

  /***/
  "react":
  /***/
  function react(module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  "react-dom":
  /***/
  function reactDom(module, exports) {
    module.exports = require("react-dom");
    /***/
  },

  /***/
  "styled-components":
  /***/
  function styledComponents(module, exports) {
    module.exports = require("styled-components");
    /***/
  }
  /******/

});